module.exports = __webpack_public_path__ + "static/media/trash.8eff3d1c.svg";